import { siteSettingsService } from '@/services'

//define module name
const MODULE_NAME = 'siteSettings/'

//define actions name
const A_DOWNLOAD_BAR = 'getDownloadBarVisibility'

//define dispatch action
export const SITE_SETTINGS_DOWNLOAD_BAR = MODULE_NAME + A_DOWNLOAD_BAR

//define mutations name
const M_DOWNLOAD_BAR = 'setDownloadBarVisibility'

//init app state
const state = {
  // null until fetched; callers fall back to the build-time env var while this is null
  hideDownloadBar: null
}

const getters = {}

const actions = {
  [A_DOWNLOAD_BAR]({ commit }) {
    siteSettingsService.getDownloadBarVisibility().then(
      data => {
        commit(M_DOWNLOAD_BAR, data)
      },
      () => {
        // leave hideDownloadBar as null on failure; shouldShowDownload() falls back to SHARED.HIDE_DOWNLOAD_BAR
      }
    )
  }
}

const mutations = {
  [M_DOWNLOAD_BAR](state, data) {
    if (data && data.success && data.data) {
      state.hideDownloadBar = data.data.hideDownloadBar
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}